var TooltipLooks = /*#__PURE__*/ function(TooltipLooks) {
    TooltipLooks["Danger"] = "danger";
    TooltipLooks["Default"] = "default";
    TooltipLooks["Primary"] = "primary";
    return TooltipLooks;
}({});
var TooltipPositions = /*#__PURE__*/ function(TooltipPositions) {
    TooltipPositions["Bottom"] = "bottom";
    TooltipPositions["Left"] = "left";
    TooltipPositions["Right"] = "right";
    TooltipPositions["Top"] = "top";
    return TooltipPositions;
}({});
var TooltipTypes = /*#__PURE__*/ function(TooltipTypes) {
    TooltipTypes["Description"] = "description";
    TooltipTypes["Label"] = "label";
    return TooltipTypes;
}({});

export { TooltipLooks, TooltipPositions, TooltipTypes };
//# sourceMappingURL=tooltip.js.map
